import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import classNames from 'classnames';
import s from './actions.module.css';
import { context } from '../utils';
const Actions = ({ children }) => {
    const { dataTest } = useContext(context);
    const single = useMemo(() => React.Children.count(children) === 1, [children]);
    return (React.createElement("div", { className: classNames(s.box, single && s.single), "data-test": dataTest && `${dataTest}-actions` }, children));
};
const isLegacyBrowser = typeof IntersectionObserver === 'undefined';
export const StickyActions = ({ children }) => {
    const { dataTest } = useContext(context);
    const [shadow, setShadow] = useState(false);
    const coverRef = useRef(null);
    useEffect(() => {
        if (isLegacyBrowser) {
            return;
        }
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                setShadow(!entry.isIntersecting);
            });
        });
        if (coverRef && coverRef.current) {
            observer.observe(coverRef.current);
        }
        return () => {
            observer.disconnect();
        };
    }, [setShadow]);
    if (isLegacyBrowser) {
        return React.createElement(Actions, null, children);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: coverRef, className: classNames(s.cover) }),
        React.createElement("div", { className: classNames(s.sticky, shadow && s.shadow), "data-test": dataTest && `${dataTest}-sticky-actions` },
            React.createElement(Actions, null, children))));
};
export default Actions;
//# sourceMappingURL=actions.js.map